export const state = {
  keyword: '',
  city: '',
  sort: 'first_name',
  role: '',
  group: '',
  edition: '',
  active: true,
  inactive: false,
  page: 1,
  perPage: 25,
  kc_program: false,
  nv_program: false,
  drauge_program: false,
  grupese_program: false,
}

export const getters = {
  usersFilters: (state) => ({
    keyword: state.keyword,
    city: state.city,
    sort: state.sort,
    role: state.role,
    group: state.group,
    edition: state.edition,
    active: state.active,
    inactive: state.inactive,
    page: state.page,
    perPage: state.perPage,
    kc_program: state.kc_program,
    nv_program: state.nv_program,
    drauge_program: state.drauge_program,
    grupese_program: state.grupese_program,
  }),
}

export const mutations = {
  SET_FILTERS(state, payload) {
    Object.keys(payload).forEach((key) => {
      const val = payload[key]
      state[key] = val
    })
  },
}

export const actions = {
  setUsersFilters({ commit }, payload) {
    commit('SET_FILTERS', payload)
  },
}
